import axios from 'axios';
import { getToken } from './User/UserRequests';

const API_BASE = process.env.REACT_APP_API_BASE_URL;

/**
 * Get all characterizations for a project
 */
export const getProjectCharacterizations = async (projectUuid) => {
  try {
    const response = await axios.get(
      `${API_BASE}/project/${projectUuid}/characterizations`,
      {
        headers: {
          authorization: `Bearer ${getToken()}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching characterizations:', error);
    throw error;
  }
};

/**
 * Create a manual characterization
 */
export const createProjectCharacterization = async (projectUuid, characterizationData) => {
  try {
    const response = await axios.post(
      `${API_BASE}/project/${projectUuid}/characterizations`,
      characterizationData,
      {
        headers: {
          authorization: `Bearer ${getToken()}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error creating characterization:', error);
    throw error;
  }
};

/**
 * Update an existing characterization
 */
export const updateProjectCharacterization = async (projectUuid, characterizationUuid, characterizationData) => {
  try {
    const response = await axios.put(
      `${API_BASE}/project/${projectUuid}/characterizations/${characterizationUuid}`,
      characterizationData,
      {
        headers: {
          authorization: `Bearer ${getToken()}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating characterization:', error);
    throw error;
  }
};

/**
 * Delete a characterization
 */
export const deleteProjectCharacterization = async (projectUuid, characterizationUuid) => {
  try {
    const response = await axios.delete(
      `${API_BASE}/project/${projectUuid}/characterizations/${characterizationUuid}`,
      {
        headers: {
          authorization: `Bearer ${getToken()}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error deleting characterization:', error);
    throw error;
  }
};

/**
 * Generate AI characterization suggestions based on questionnaire responses
 */
export const generateAICharacterization = async (projectUuid, requestData) => {
  try {
    const response = await axios.post(
      `${API_BASE}/project/${projectUuid}/characterizations/generate-ai`,
      requestData,
      {
        headers: {
          authorization: `Bearer ${getToken()}`
        },
        timeout: 120000 // 2 minutes timeout for AI generation
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error generating AI characterization:', error);
    throw error;
  }
};

/**
 * Set a characterization as active (selected) for the project
 */
export const setActiveCharacterization = async (projectUuid, characterizationUuid) => {
  try {
    const response = await axios.post(
      `${API_BASE}/project/${projectUuid}/characterizations/${characterizationUuid}/set-active`,
      {},
      {
        headers: {
          authorization: `Bearer ${getToken()}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error setting active characterization:', error);
    throw error;
  }
};